import { DirectUpload } from "@rails/activestorage"

class ActiveStorageDirectUploader {
  constructor(file) {
    this.uploader = new DirectUpload(file, 
      '/rails/active_storage/direct_uploads', this
    )
  }

  upload({onComplete, onError, onProgress}) {
    this.onProgress = onProgress;
    this.uploader.create((error, blob) => {
      if (error) {
        onError(error);
      } else {
        onComplete(blob);
      }
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    // Use event.loaded and event.total to update the progress bar
    this.onProgress && this.onProgress(Math.round(event.loaded / event.total * 100));
  }
}

export default ActiveStorageDirectUploader;
